import { OnInit, Optional, Inject, Component, ViewChild ,Injectable} from '@angular/core';
import { HttpClient} from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class SymbolService {
  private appSettings: any;
  modNewsUrl : any;
 
  constructor(private _http: HttpClient,
    @Optional() @Inject('AppSettings') appSettings: any
    ) {
      this.modNewsUrl = appSettings.ibdConfigMap.modApiUrl;
    }

  navigateSymbol(symbol: any) {
    let quoteUrl = "";
    let quoteParam = {};
    this.getData(symbol, this.modNewsUrl).subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          let modSymbolResponse;
          let found = false;
          for (let k = 0; k < data.length; k++) {
            if (data[k].Symbol === symbol) {
              found = true;
              modSymbolResponse = data[k];
              break;
            }
          }

          if (found === true && typeof modSymbolResponse !== "undefined") {
            if (typeof modSymbolResponse["NormalIssueType"] !== "undefined") {
              if (modSymbolResponse["NormalIssueType"] == "S") {
                quoteUrl = "/nxi/research/quotenews/stocks/summary";
                quoteParam = { Symbol: symbol };
              } else if (modSymbolResponse["NormalIssueType"] == "ETF") {
                quoteUrl = "/nxi/research/quotenews/etf/etfsummary";
                quoteParam = { Symbol: symbol };
              } else if (modSymbolResponse["NormalIssueType"] == "MF") {
                quoteUrl = "/nxi/research/quotenews/mutualfunds/mfsummary";
                quoteParam = { Symbol: symbol };
              } else if (modSymbolResponse["NormalIssueType"] == "INX") {
                quoteUrl = "/nxi/research/quotenews/overviewnews";
                quoteParam = { Symbol: symbol };
              } else {
                quoteUrl = "/nxi/research/quotenews/overviewnews";
                quoteParam = { Symbol: symbol };
              }
            } else {
              quoteUrl = "/nxi/research/quotenews/overviewnews";
              quoteParam = { Symbol: symbol };
            }
          } else {
            quoteUrl = "/nxi/research/quotenews/overviewnews";
            quoteParam = { Symbol: symbol };
          }
          this.goto(quoteParam, quoteUrl);
        } else {
          //console.log("NO DATA FOUND IN SYMBOL LOOKUP");
          this.goto(quoteParam, "/nxi/research/quotenews/overviewnews");
        }
      },
      (err) => {
        console.log(err);
        this.goto(quoteParam, "/nxi/research/quotenews/overviewnews");
      }
    );
  }

  private getData(symbol: any,modurl: any): any {
    let urlStart = modurl+'/public/lookup';
    let params = [];
    params.push("symbol=" + symbol + "&normalizeAssetType=true");
    let url = urlStart + "?" + params.join("&");
    return this._http.jsonp(url, "callback");
  }

 private goto(quoteParam: any, quoteUrl: string) {
    document.dispatchEvent(
      new CustomEvent("portal.gotoview", {
        detail: {
          gotoParams: quoteParam,
          gotoPage: quoteUrl,
        },
      })
    );
  }
}
